import { createContext } from 'react';
import manifest from './manifest';

export const ManifestContext = createContext(manifest);
function ComponentManifest({ manifest, children }) {
	return <ManifestContext.Provider value={manifest}>{children}</ManifestContext.Provider>;
}

export default ComponentManifest;
